import React from 'react';
import {Link} from "react-router-dom";
import {useIntl} from "react-intl";
import gift from '../../gift.png';
import './index.css'
import useGA from "../../hooks/useGA";
import Share from "../../components/share";

interface WelcomeProps {
  next: string
}

const Welcome = ({next}: WelcomeProps) => {
  const intl = useIntl()
  const sendEvent = useGA('welcome');

  return (
    <>
      <div className={'page'}>
        <div className={'page-title main-ttl'}>
          {intl.formatMessage({
            id: 'WELCOME'
          })}
        </div>
        <div className={'main-sub-ttl'}>
          Discover the perfect gift in just 5 simple steps
        </div>

        <div className={'middle'}>
          <div className={'white-circle'}>
            <img src={gift} className="App-logo" alt="logo"/>
          </div>
        </div>
        <Link className={'button-19 welcome-button'}
              onClick={() => {
                sendEvent('navigate', {target: next, current: 'welcome'})
              }}
              to={next}>
          {intl.formatMessage({id: 'START'})}
        </Link>
        <div className={'links'}>
          <a href={'/explore'}>explore</a>
          <Link to={'https://blog.giftely.ai'} target={'_blank'}>blog</Link>
          <Link to={'/privacy'}>privacy policy</Link>
          <Link to={'/terms'}>terms and conditions</Link>
          <Share/>
          <Link to={'mailto:feedback@blog.giftely.ai?subject=GiftelyAI'} target={'_blank'}>contact us</Link>
        </div>
      </div>
    </>
  );
}

export default React.memo(Welcome);
